/*
 * @Author: Dong
 * @Date: 2022-04-06 14:08:22
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-14 14:37:30
 */
import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { Layout, Spin } from 'sup-ui';
import { common } from 'root/store/actions';
import spinBg from 'root/assets/images/illustrator_check.png';
import SiderMenu from './SiderMenu';
import messages from './messages';
import styles from './index.less';
import { checkHostStatusApi } from 'root/services/disk';
import Header from './Header';
const { Content } = Layout;

const currentHash = location.hash.replace('#', '');

let startTime: any = '';

// 各状态对应的路由
const statusRoute: { [x: string]: string } = {
  guide: '/guide',
  supos: '/supos', // supos安装
  installed: ['/guide', '/supos', '/', ''].includes(currentHash) ? '/envManage' : currentHash, // 已完成安装,进入平台管理页面
  inductive: '/inductive',
};

const AppLayout = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [spinning, setSpinning] = useState(true);

  useEffect(() => {
    // 监听当前history变化

    window.hashHistory.listen((params: any) => {
      const {
        location: { key, pathname },
        action,
      } = params;

      if (action === 'POP') {
        // 手动修改url，刷新页面
        // __dev__ 留个口子，自测用
        if (key === 'default' && !window.localStorage.getItem('__dev__')) {
          window.location.reload();
        }
      } else {
        navigate(pathname);
      }
    });
  }, []);

  // 运行环境检测
  useEffect(() => {
    startTime = Date.now();
    checkHostStatusApi().then((res) => {
      const {
        data: { runtimeEnvList = [] },
      } = res;

      dispatch(common.updateEnv({ hasEnv: runtimeEnvList.length ? true : false }));
      setSpinning(false);
      return jumpTo({
        route: 'installed',
      });
    });
  }, []);

  const removeSpinning = () => {
    // 控制2s检测时间
    const delay = Date.now() - startTime > 2000 ? 0 : 2000 - (Date.now() - startTime);
    setTimeout(() => {
      // 隐藏环境检查提示
      setSpinning(false);
    }, delay);
  };

  const jumpTo = ({ route }: { route: string }) => {
    removeSpinning();
    // 跳转到对应状态下的路由
    navigate(statusRoute[route]);
  };

  return (
    <Layout className={styles.container}>
      {spinning && (
        <Spin
          className={styles.spin}
          indicator={<img src={spinBg} />}
          spinning={spinning}
          tip={intl.formatMessage(messages.checkEnv)}
        />
      )}
      <SiderMenu className={styles.sider} />
      <Layout className={styles.content}>
        <Header />
        <Content>{!spinning && <Outlet />}</Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
